import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { userProfileApi } from 'src/api/administration/user-profile-api';
import { useAppSelector } from 'src/app/hooks';
import { fetchToken } from 'src/firebase';

export interface UserState {
  username: string;
  fullName: string;
  deptName?: string | undefined;
  avatar?: string | undefined;
  roleId?: string | undefined;
  gender?: string | undefined;
  birthDay?: Date | undefined;
  roleName?: string | undefined;
  deptId: string;
  myDeptIds: string[];
  userType: string;
  deptsAdmin: string[];
  isMenuReportTCT?: boolean;
  isMenuReportIndicator?: boolean;
}

const initialState: UserState = {
  username: '',
  fullName: '',
  deptName: '',
  avatar: '',
  roleId: '',
  deptId: '',
  myDeptIds: [],
  userType: '',
  deptsAdmin: [],
};

export const getUserInfo = createAsyncThunk(
  'auth/info',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (!state.userInfo.roleId) {
      const userProfile = await userProfileApi.getCurrentUser();
      await fetchToken((obj: any) => {});
      return userProfile;
    }
  },
);

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      getUserInfo.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.username = action.payload.username;
          state.fullName = action.payload.fullName;
          state.deptName = action.payload.deptName;
          state.avatar = action.payload.avatar;
          state.roleId = action.payload.roleId;
          state.gender = action.payload.gender;
          state.birthDay = action.payload.birthDay;
          state.roleName = action.payload.roleName;
          state.deptId = action.payload.deptId;
          state.myDeptIds = action.payload.myDeptIds;
          state.userType = action.payload.userType;
          state.deptsAdmin = action.payload.deptIds;
          state.isMenuReportTCT =
            action.payload.isMenuReportTCT;
          state.isMenuReportIndicator =
            action.payload.isMenuReportIndicator;
        }
      },
    );
  },
});

export const {} = userInfoSlice.actions;

export const selectUserInfo = (state: RootState) =>
  state.userInfo;

export default userInfoSlice.reducer;
